import type { ReactElement } from 'react';
import { memo } from 'react';

import { Image } from '@bestseller-bit/frontend-community.components.image';
import Box, { type BoxProps } from '@mui/material/Box';

interface MenuItemThumbnailProps extends Partial<BoxProps> {
    /** The alt text for the image */
    alt?: string;
    /** The source URL for the image */
    src?: string;
    /** Whether the image is loading or not @default false */
    isLoading?: boolean;
}

const MenuItemThumbnailRaw = ({
    alt = 'menu-item-thumbnail',
    src,
    isLoading = false,
    ...boxProps
}: MenuItemThumbnailProps): ReactElement => (
    <Box
        {...boxProps}
        sx={{
            position: 'relative',
            flexShrink: 0 /* Prevents the wrapper from shrinking */,
            width: 52,
            overflow:
                'hidden' /* Hides parts of the image that are outside the rounded corners */,
            minHeight: 64,
            alignSelf: 'stretch',
            backgroundColor: ({ palette }) => palette.background.secondary,
            // eslint-disable-next-line @typescript-eslint/no-misused-spread
            ...boxProps.sx,
        }}
    >
        <Image
            src={src}
            alt={alt}
            objectFit="cover"
            isLoading={isLoading}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
            }}
        />
    </Box>
);

MenuItemThumbnailRaw.displayName = 'MenuItemThumbnail';

const MenuItemThumbnail = memo(MenuItemThumbnailRaw);

export { MenuItemThumbnail };
